<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <h1>Promoção - {{ tituloPromocao }}</h1>
    <b-row class="p-b-20">
      <b-col md="6" xl="6" sm="12">
        <b-button class="btn btn-danger m-w" @click="goBack">Cancelar</b-button>
      </b-col>
      <b-col md="6" xl="6" sm="12">
        <b-button class="btn btn-success m-w" @click="save" :disabled="!saveBtn"
          >Salvar</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" v-if="imageSource != null && imageSource != ''">
        <b-card header="Imagem Atual">
          <img
            :src="imageSource"
            alt="Imagem da Promoção"
            style="width: 100%"
          />
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header="Editar Imagem">
          <picture-input
            ref="pictureInput"
            :zIndex="10"
            style="width: 100%"
            margin="16"
            accept="image/jpeg, image/png"
            size="10"
            button-class="btn"
            :custom-strings="{
              upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
              drag: 'Arraste uma imagem <br> (ou clique aqui)',
              change: 'Mudar foto',
            }"
            @change="onChange"
          ></picture-input>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";
import Loading from "vue-loading-overlay";

export default {
  name: "editarimagem",
  components: { PictureInput, Loading },
  data: function () {
    return {
      imageSource: null,
      tituloPromocao: null,
      saveBtn: false,
      selecionado: 2,
      isLoading: false,
    };
  },
  methods: {
    onChange(image) {
      if (image) {
        this.saveBtn = true;
        localStorage.setItem("image", image);
      } else {
        this.saveBtn = false;
      }
    },
    goBack() {
      localStorage.removeItem("titulo_promocao");
      localStorage.removeItem("url_imagem");
      localStorage.removeItem("image");
      localStorage.removeItem("id_promocao");
      this.$router.go(-1);
    },
    async save() {
      this.isLoading = true;
      const url = `${config.default.servidor}/gerencial/promocao/imagem`;
      try {
        const response = await axios({
          url,
          method: "post",
          data: {
            empresaid: localStorage.getItem("enterprise_id").toString(),
            promocaoid: localStorage.getItem("id_promocao").toString(),
            imagem: localStorage.getItem("image"),
          },
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.isLoading = false;
          await this.$alert("Imagem Atualizada!", "Sucesso", "success");
          this.goBack();
        }
      } catch (error) {
        this.isLoading = false;
        await this.$alert("Falha ao atualizar imagem!", "Erro", "error");
      }
    },
  },
  beforeMount() {
    this.imageSource = localStorage.getItem("url_imagem").toString();
    this.tituloPromocao = localStorage.getItem("titulo_promocao").toString();
  },
};
</script>